module.exports = __webpack_public_path__ + "static/media/radio-filled.3e0fb956.svg";